module.exports = __webpack_public_path__ + "static/media/logo-kjp.1e7b750e.jpg";